/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */


import React, {Component, PropTypes} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';

import ScrollArea from '../../../../ScrollArea';
import Tooltip from 'rc-tooltip';

import {StubFunc, getScroll} from '../../../../../utils';
import {FetchAssetById} from '../../../../../actions/asset/action-asset';
import {OpenMessage, SetSettingsState, GetPurchases} from '../../../../../actions/common/actions-common';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';

import moment from 'moment';
import _get from 'lodash/get';
import _maxBy from 'lodash/maxBy';

class PackageProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-package-poster-profile.png`,
      streamUrl: ''
    };
  }

  componentDidMount() {

    this._fetchPackageAssetData(_get(this.props, 'pckageId', null));

    if (this.props.pckage.id) {

      lh.models.asset.methods
        .getPosterUrl(this.props.pckage, {
          crop: {x: 270, y: 270},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-package-poster-profile.png`});
        });
    }
  }

  componentWillReceiveProps(newProps) {

    if (this.props.pckageId !== newProps.pckageId) {

      this._fetchPackageAssetData(_get(newProps, 'pckageId', null));
    }

    if (newProps.pckage.id && newProps.pckage.id !== this.props.pckage.id) {

      lh.models.asset.methods
        .getPosterUrl(newProps.pckage, {
          crop: {x: 270, y: 270},
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-package-poster-profile.png`});
        });
    }
  }

  _fetchPackageAssetData(pckageId) {
    this.props.FetchAssetById(pckageId, 'package');

  };

  _closeProfile() {

    this.props.onClose();
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: this.props.pckage.id,
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  _isNeedToPurchase(asset = this.props.pckage) {

    return !asset.is_purchased && !asset.is_available && !asset.is_free;
  }

  _renderOffers() {
    if (!this.props.pckage.offers || !this.props.pckage.offers.length) return <noscript />;

    if (this.props.pckage.is_purchased) {

      return <noscript />;
    }

    if (!this.props.pckage.is_available && this.props.pckage.is_free) {

      return <div className="profile-bigtext"><Translate content="profile.offers.type.free" /></div>;
    }

    return this.props.pckage.offers.map(function (offer, index) {

      if (offer.type === 'transactional') {
        if (_get(offer, 'right_params.duration') === 0) {
          offer._typeParsed = 'transactional-own';
        } else {
          offer._typeParsed = 'transactional-rent';
        }
      } else {
        offer._typeParsed = offer.type;
      }

      return (
        <div className="offer" key={'offer_' + offer.id + '_' + index}>
          <div className="offer-type color-grey">
            <Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} />
            {(offer.is_from_package) ?
              <Tooltip
                placement="top"
                destroyTooltipOnHide={true}
                overlay={
                  <div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
                    <Translate content="profile.packages.bundle" />: {offer.parent.title || ''}
                  </div>}>
                <i className="ml- ic ic-tickets"></i>
              </Tooltip>
              : ''}
          </div>
          <div className="offer-price pointer">
            <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
            <span>{_get(offer, 'billing_params.price') / 100}</span>
            {(_get(offer, 'type') === 'subscription') ?
              ('/' + (_get(offer, 'right_params.duration') > 1 ?
              _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit') + '(s)')
              : ''}
          </div>
        </div>
      );
    });
  }

  _renderIncluded() {

    return _get(this.props.pckage, '_assets2', []).map((asset, index) => {

      return (<div key={'asset_' + asset.id}><Link to={'/asset/' + asset.id}>
        {index + 1}. {asset.title}
      </Link></div>);
    });
  }

  _renderEnt() {

    let maxEntData = _maxBy(this.props.ent, 'ent_expiration_time');
    if (maxEntData) {

      maxEntData = moment.unix(maxEntData.ent_expiration_time);
    }

    return (
      <div className="profile-r pr purchase-container">
        <div className="subscription-title-3">
          <strong><Translate content="profile.packages.expires" />:</strong>
        </div>
        <div className="profile-included">
          {maxEntData ? maxEntData.format('LLL') : <div className="profile-bigtext">
            <Translate content={'profile.packages.bought'} />
          </div>}
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.pckage.id) return <div className="profile movie-inf-example movie-inf-profile bg-black radius"><DivLoader loading={true} /></div>;

    return (<div className="profile movie-inf-example movie-inf-profile bg-black radius">
      <DivLoader loading={this.props.inProgress} />
      <div className="profile-cols relative">
        <div className="block-2 pr">
          <div className="crow no-gutter pointer pr">
            <img id="profile_poster" src={this.state.picture} alt="" style={{width: '270px', height: '270px'}} />
          </div>
        </div>
        <div className="block-2">
          <div className="profile-r pr">
            <div className="profile-title">
              {_get(this.props.pckage, 'title', '')}
            </div>
            <ScrollArea
              speed={0.8}
              className="profile-text"
              horizontal={false}
              smoothScrolling={true}>
              <div>{_get(this.props.pckage, 'description', '')}</div>
            </ScrollArea>
          </div>
        </div>
        <div className="block-2">
          <div className="profile-r pr">
            <div className="subscription-title-3">
              <strong><Translate content="profile.packages.included" />:</strong>
            </div>
            <ScrollArea
              speed={0.8}
              className="profile-included"
              horizontal={false}
              smoothScrolling={true}>
              <div>{this._renderIncluded()}</div>
            </ScrollArea>
          </div>
        </div>
        <div className="block-2">
          { !this.props.pckage.is_purchased && !this.props.pckage.is_available &&
          <div className="profile-r pr purchase-container">
            <ScrollArea
              speed={0.8}
              className="offers-wrapper"
              horizontal={false}
              smoothScrolling={true}>
              {this._renderOffers()}
            </ScrollArea>
            {!this.props.pckage.is_free && <div className="purchase-ico mt hover" onClick={this._showOffers.bind(this)}>
              <i className="ic ic-shopping-cart"></i>
            </div>}
          </div>}
          {!!this.props.pckage.is_purchased && this._renderEnt()}
        </div>
      </div>
      <a className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
    </div>);
  }
}

PackageProfile.propTypes = {
  pckageId: PropTypes.number.isRequired,
  pckage: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  inProgress: PropTypes.bool.isRequired
};

PackageProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from Package Profile')
};

const mapStateToProps = function ({assets, auth: {user}, purchases: {purchases}}, ownProps) {
  let asset = _get(assets, _get(ownProps, 'pckageId', null), {});
  let ent = purchases.filter((purchase) => {

    return purchase.asset_id === _get(ownProps, 'pckageId', null);
  });

  return {
    user: user,
    pckage: asset,
    ent: ent,
    inProgress: !!asset._fetchInProgress
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({
    FetchAssetById,
    OpenMessage,
    SetSettingsState,
    GetPurchases
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/Package/package-profile.js